/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { RvNewLimitFormDto } from '../../models/rv-new-limit-form-dto';
import { SafetyDto } from '../../models/safety-dto';

export interface UpdateLimit$Params {
  id: number;
  customerGUID: string;
      body: RvNewLimitFormDto
}

export function updateLimit(http: HttpClient, rootUrl: string, params: UpdateLimit$Params, context?: HttpContext): Observable<StrictHttpResponse<SafetyDto>> {
  const rb = new RequestBuilder(rootUrl, updateLimit.PATH, 'put');
  if (params) {
    rb.path('id', params.id, {});
    rb.query('customerGUID', params.customerGUID, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<SafetyDto>;
    })
  );
}

updateLimit.PATH = '/rv/safeties/{id}/update-limit';
